<script>
import FormModal from '../modals/FormModal.vue';
import FormFileInput from '../forms/FormFileInput.vue';
import axios from "axios";
import { Inertia } from '@inertiajs/inertia';

export default {
    components: {
        FormModal, FormFileInput
    },
    props: {
        showModal: Boolean,
        modalTitle: String,
        type: {
            type: Number,
            default: 0
        },
        submitType: {
            type: Number,
            default: 0
        }
    },
    data() {
        let modalTitle = `Create ${this.modalTitle}(Bulk import)`
        return {
            isButtonLoading: false,
            isShowSubmitButton: true,
            submitButtonText: 'Submit',
            massModalTitle: modalTitle,
            errors: {},
            uploadFileData: {
                attachment: null
            },
            downloadCsvUrl: null,
            isToggleDataTable: false,
            items: [],
            submitData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            isSubmitData: false
        }
    },
    methods: {
        hideModal(){
            this.$emit('onClose')
            this.refreshModal()
        },
        refreshModal() {
            this.uploadFileData.attachment = null
            this.errors = {}
            this.items = []
            this.submitData = []
            this.isShowSubmitButton = true
            this.isToggleDataTable = false
            this.isSubmitData = false
            this.totalRows = 1
            this.currentPage = 1
        },
        handleClientCreateSubmit() {
            if(this.isSubmitData) {
                this.readyToSubmitData()
            }
            else {
                this.readCsvFromFile()
            }
        },
        readyToSubmitData() {
            this.errors = {}
            let routeUrl = route('create-users-from-csv')
            let formData = new FormData()
            this.$refs.topProgress.start()
            formData.append('data', this.submitData)
            formData.append('submit_type', this.submitType)
            this.isButtonLoading = true;
            this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                        ></i>
                        Loading`;
            axios.post(routeUrl, formData,{})
            .then(response => {
                this.submitButtonText = 'Submit';
                this.isButtonLoading = false;
                this.$refs.topProgress.done()
                if(response.data.blank_error) {
                    report_error(location.pathname, 'read csv bulk creation');
                    return false
                }
                if(response.data.error) {
                    this.$toastr.e(response.data.error);
                } else if(response.data.success) {
                    this.$toastr.s(response.data.success);
                    if(!response.data.registered) {
                        this.hideModal()
                        Inertia.reload()
                    }
                }
                if(response.data.registered && response.data.registered.length) {
                    this.errors.registered = "<div class='text-danger mb-2 col-8'><ul>"
                    for(let x of response.data.registered) {
                        this.errors.registered += `<li>${x}</li>`
                    }
                    this.errors.registered += '</ul></div>'
                }
            })
            .catch(errors => {
                if (errors.message) {
                    this.$toastr.e(errors.message);
                }
                this.isButtonLoading = false;
                this.submitButtonText = 'Submit';
                this.$refs.topProgress.done()
            });
        },
        readCsvFromFile() {
            let routeUrl = route('read-csv-registration')
            let formData = new FormData(this.$refs.uploadCSV)
            this.$refs.topProgress.start()
            formData.append('operation_type', this.type)
            formData.append('submit_type', this.submitType)
            this.isButtonLoading = true;
            this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                        ></i>
                        Loading`;
            
            axios.post(routeUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                if(response.data.file_error) {
                    this.errors = {
                        ...this.errors,
                        file_error: response.data.file_error
                    }
                }
                if(response.data.has_data_err) {
                    this.isSubmitData = true
                    this.isShowSubmitButton = false
                    this.errors.err_data = ''
                    for(let x of response.data.err_data) {
                        this.errors.err_data += `<div class='text-danger mb-2 ms-3'>${x.type} : <span>${x.row}</span></div>`
                    }
                }
                if(response.data.data && response.data.data.length) {
                    this.isSubmitData = true
                    this.items = response.data.data
                    this.isToggleDataTable = true
                }
                if(response.data.submitData && response.data.submitData.length) {
                    this.isSubmitData = true
                    this.submitData = JSON.stringify(response.data.submitData);                        
                    this.isShowSubmitButton = true
                }
                this.totalRows = this.items.length
                this.isButtonLoading = false;
                this.submitButtonText = 'Submit';
                this.$refs.topProgress.done()         
            })
            .catch(errors => {
                if (errors.message) {
                    this.$toastr.e(errors.message);
                }
                this.isButtonLoading = false;
                this.submitButtonText = 'Submit';
                this.$refs.topProgress.done()
            });

        },
        handleCsvDownloadUrl() {
            let pathOriginalLocation = '/public/demo_files/'
            if(this.type == 1 && this.submitType == 1) {
                this.downloadCsvUrl = pathOriginalLocation +'demo_admin_to_sb_create_listing.csv' 
            }
            else if(this.type == 2 && this.submitType == 2) {
                this.downloadCsvUrl = pathOriginalLocation + 'demo_admin_to_tc_create_listing.csv'
            }
            else if(this.type == 2 && this.submitType == 3) {
                this.downloadCsvUrl = pathOriginalLocation + 'demo_admin_to_tp_create_listing.csv'
            }
            else if(this.type == 3 && this.submitType == 4) {
                this.downloadCsvUrl = pathOriginalLocation + 'demo_sb_to_tc_create_listing.csv'
            }
            else {
                this.downloadCsvUrl = pathOriginalLocation + 'demo_tc_to_tp_create_listing.csv'
            }
            if(this.downloadCsvUrl) {
                this.downloadCsvUrl = `(<a download href="${this.downloadCsvUrl}">Download an example .csv file to create ${this.modalTitle}</a>)`
            }
            else {
                this.downloadCsvUrl = ''
            }
        }
    },

    computed: {
        // Example 1,2,3,4
        userType() {
            return this.$page.props.auth.user.user_type;
        }
    },
    mounted() {  
        let self = this
        if(self.submitType != 0 && self.type != 0) {     
            self.handleCsvDownloadUrl()
        }
    }
};
</script>

<template>
    <div>
        <vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
        <FormModal
            :isShow="showModal"
            :title="massModalTitle"
            modalSize="lg"
            :isButtonLoading="isButtonLoading"
            :isShowSubmitButton="isShowSubmitButton"
            :isShowCancelButton="true"
            :isModalScrollable="true"
            :clickSubmitButton="handleClientCreateSubmit"
            :submitButtonText="submitButtonText"
            @hideModal="hideModal"
        >
            <template v-if="(errors.err_data || errors.registered) && isSubmitData">
                <div class="d-flex justify-content-between align-items-start">
                    <div v-if="errors.registered" v-html="errors.registered"></div>
                    <div v-else class="col-8">
                        <h6 class="text-danger">Types of error with CSV row numbers:-</h6>
                        <div v-html="errors.err_data"></div>
                    </div>
                    <div><b-button @click="refreshModal" variant="info">Try again</b-button></div>
                </div>
            </template>
            <div v-if="isToggleDataTable && isSubmitData">
                <b-table
                    :items="items"
                    :current-page="currentPage"
                    :per-page="perPage"
                    stacked="sm"
                    sticky-header
                    striped
                    responsive
                    outlined
                    hover
                    bordered
                    show-empty
                    small
                >
                </b-table>

                <div class="d-flex justify-content-end">
                    <b-col sm="7" md="6" class="my-1">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0"
                        ></b-pagination>
                    </b-col>
                </div>
            </div>
            <div v-if="!isSubmitData">
                <form ref="uploadCSV" enctype="multipart/form-data">
                    <FormFileInput
                        label='Upload CSV'
                        :textWithHtml="downloadCsvUrl" 
                        v-model='uploadFileData.attachment'
                        :required="true"
                        :error="errors.file_error"
                        name="upload_file"
                    />
                </form>
            </div>
        </FormModal>
    </div>
</template>
